export default {
  'site.title': '开云足球·官方落地页｜极致足球体验平台',
  'site.description': '开云足球是专注足球赛事、数据分析与互动体验的综合平台。无论您是足球爱好者还是专业玩家，开云足球为您提供实时赛事资讯、精准数据支持与沉浸式足球互动服务，立即加入开云足球，开启您的极致足球之旅。',
};